import { render, staticRenderFns } from "./skeletonRow.vue?vue&type=template&id=55576c01&"
var script = {}
import style0 from "./skeletonRow.vue?vue&type=style&index=0&id=55576c01&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports